import { useEffect } from "react";
import ganttChartService from "../../service/ganttChartService";
import { TimeRange } from "../../types/ganttChart";
import dateUtil from "../../utils/dateUtil";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  setTimelineArrayOfTimeStrings,
  setTimelineRange,
} from "../../store/timeline";
import VerticalGanttChartTimelineColumn from "./verticalGanttChart/VerticalGanttChartTimelineColumn";
import timelineService from "../../service/timelineService";
import useDataSelector from "../../hooks/useDataSelector";

const SharedTimelineComponent = () => {
  const { selectedGanttChartTab } = useAppSelector(
    (state) => state.ganttChartSlice,
  );
  const { dataToUse } = useDataSelector();
  const { selectedNexusFilterDate } = useAppSelector(
    (state) => state.nexusFiltersSlice,
  );
  const dispatch = useAppDispatch();

  const { timelineRange } = useAppSelector((state) => state.timelineSlice);

  useEffect(() => {
    if (dataToUse && selectedNexusFilterDate) {
      const selectedDate = new Date(selectedNexusFilterDate);
      const timeRange: TimeRange = ganttChartService.sortAccordingToStartDate(
        dataToUse.employees,
        dataToUse.generalGanttChartInfo.unplannedTasks,
        selectedGanttChartTab,
      );

      // This hour changes according to zoom
      const defaultHourToScrollTo = timelineService.getFirstHourInView(
        timeRange.startDate,
      );
      // This hour is static once set
      const earliestHourDisplayedOnTimeline =
        timelineService.getEarliestHourDisplayedOnTimeline(timeRange.startDate);

      const fullWorkDayInHours =
        //@ts-ignore
        (new Date(timeRange.endDate) -
          new Date(selectedNexusFilterDate).setHours(0, 0, 0, 0)) /
        (1000 * 60 * 60);

      // set data to define time points on axis and set the basis for pixelsPerMinute etc.
      dispatch(
        setTimelineRange({
          chosenDate: selectedDate.toISOString(),
          firstHourInView: defaultHourToScrollTo,
          lastVisibleHour: timeRange.endDate,
          fullDayHours: fullWorkDayInHours + 1,
          earliestHourDisplayedOnTimeline: earliestHourDisplayedOnTimeline,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataToUse]);

  useEffect(() => {
    if (timelineRange) {
      dispatch(
        setTimelineArrayOfTimeStrings(
          dateUtil.generateTimelineData(timelineRange),
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timelineRange]);

  return <VerticalGanttChartTimelineColumn />;
};

export default SharedTimelineComponent;
